import { Form, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  ModalBodyBlack,
  ModalFooterBlack,
  ModalHeaderBlack,
  MyModal,
} from "../../features/RadConnStyle";

export default function PopupReportStateOption(props) {
  const [winState, setState, repcheck, setRepCheck, enableSave, dataX] =
    props.winState;

  const [minRep, setMinRep] = useState(1);

  const handleClose = (value) => {
    let result = { confirm: value, resultType: minRep >= 3 ? 4 : repcheck };
    winState.action(result);
    setState({ show: false });
  };

  useEffect(() => {
    if (winState?.show === true) {
      setMinRep(
        (dataX?.studyResult &&
          dataX.studyResult.length > 0 &&
          dataX.studyResult[0]?.result_type_id) ||
          1
      );

      setRepCheck(
        (dataX?.studyResult &&
          dataX.studyResult.length > 0 &&
          dataX.studyResult[0]?.result_type_id) ||
          3
      );
    }
    return () => {
      setMinRep(1);
    };
  }, [winState?.show]);

  useEffect(() => {
    // console.log(dataX);
    // console.log(minRep);
  }, [minRep]);

  const onSelectChanged = (e) => {
    setRepCheck(Number(e.target.value));
  };

  const theme = useSelector((s) => s.theme.theme);
  return (
    <MyModal
      data-theme={theme.themeName}
      show={winState && winState.show}
      centered
    >
      <ModalHeaderBlack
        style={{ display: "flex", justifyContent: "center", color: "#0b9cb6" }}
      >
        เลือกประเภทผล
      </ModalHeaderBlack>
      <ModalBodyBlack style={{ justifyContent: "center" }}>
        {/* <MsgBox> เลือกประเภทการส่งผล </MsgBox> */}

        <div
          style={{
            flex: "1",
            display: "flex",

            borderRadius: "10px",
            flexDirection: "row",

            border: "3px solid #b6eeee",
            marginInline: "10px",

            justifyContent: "center",
            paddingBlock: "50px",
          }}
        >
          <div style={{ width: "150px" }}>
            <Form.Check
              disabled={!enableSave}
              name="reptype"
              type="radio"
              label="Finalized"
              style={radioStyle}
              value="3"
              radioGroup="0"
              // defaultChecked = {repcheck ===3 ? true : false}
              checked={repcheck >= 3 ? true : false}
              onChange={(e) => onSelectChanged(e)}
            />

            <Form.Check
              disabled={!(enableSave && minRep < 3)}
              name="reptype"
              value="2"
              type="radio"
              label="Preliminary"
              style={radioStyle}
              radioGroup="0"
              checked={repcheck == 2 ? true : false}
              // defaultChecked = {true}
              onChange={(e) => onSelectChanged(e)}
            />

            <Form.Check
              disabled={!(enableSave && minRep < 2)}
              name="reptype"
              value="1"
              type="radio"
              label="Draft"
              style={radioStyle}
              radioGroup="0"
              checked={repcheck == 1 ? true : false}
              onChange={(e) => onSelectChanged(e)}
            />
          </div>
        </div>
      </ModalBodyBlack>

      <ModalFooterBlack style={{ display: "flex", justifyContent: "center" }}>
        <button class="btn-blue" onClick={() => handleClose(true)}>
          ยืนยันการบันทึกผล
        </button>
        <button class="btn-red" onClick={() => handleClose(false)}>
          ยกเลิก
        </button>
      </ModalFooterBlack>
    </MyModal>
  );
}

const radioStyle = {
  color: "#111111",
  flex: "1",
  marginLeft: "20px",
  marginRight: "0px",
  cursor: "pointer",
  fontWeight: "bold",
};

export const GetConfirmTitle = (type) => {
  switch (type) {
    case "DELETE":
      return "ยืนยันการลบรายการ";
    case "UPDATE":
      return "ยืนยันการแก้ไขรายการ";
    case "ACCEPT_CASE":
      return "ยืนยันการรับเคส";
    default:
      return "กรุณายืนยัน";
  }
};
